import { AlternativeAutoComplete } from 'common/form/autoComplete/_alternativeAutoComplete'
import { Option } from 'common/form/autoComplete/_option'
import { Text } from 'common/text'
import { THEME_COLORS } from 'common/theme/_colors'
import useProductGroupFilter from 'Pages/productGroup/hook/useProductGroupFilter'
import React from 'react'

const CategoryParent = () => {
  const {categories} = useProductGroupFilter()

  return (
    <AlternativeAutoComplete
        className="principal-filter-form__input-wide"
          // main input
          inputProps={{
            categoryList: [], // menu list in category dropdown
            categoryValue: {name: 'Danh mục cha', value: ''}, // if not exist this value -> default category: categoryList[0]
            categoryWidth: 120,
            placeholder: 'Chọn danh mục cha',
            readOnly: true,
            value:
              categories?.value?.length > 0 ? `Đã chọn ${categories?.value?.length}` : '',
            onIconClick: categories?.onInputReset,
          }}
          // menu
          menuProps={{
            empty:
              categories?.list?.length <= 0
                ? categories?.tab === 'all'
                  ? 'Không tìm thấy danh mục cha'
                  : 'Bạn chưa chọn danh mục cha nào'
                : '',
            multipleChoices: true,
            onReset: categories?.onInputReset, // only use this prop for multiple choice
          }}
          // search input in dropdown menu
          searchInputProps={{
            placeholder: 'Tìm kiếm danh mục cha',
            // value: keyword,
            onChange: categories?.onKeywordChange,
          }}
          // tab list <only use this prop for multiple choices>
          tabProps={{
            active: categories?.tab,
            checkedNumber: categories?.value?.length,
            onChange: categories?.onTabChange,
          }}
        >
          {categories?.list?.length > 0 &&
            categories?.list.map(item => (
              <Option
                key={item.value}
                className="order-filter-form__option-text"
                checked={!!categories?.value?.find(find => find.id === item.id)}
                multipleChoices={true}
                style={{marginBottom: 16}}
                onClick={() => categories?.onChange(item)}
              >
                <Text color={THEME_COLORS.gray_900} style={{display: 'block'}}>
                  {item.title}
                </Text>
              </Option>
            ))}
        </AlternativeAutoComplete>
  )
}

export default CategoryParent
